<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-input v-model="searchData.name" placeholder="请输入姓名"></el-input>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.classId" @change="pageChange" filterable
                                           placeholder="选择班级">
                                    <el-option
                                        v-for="item in classItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.firstClassId" @change="pageChange" filterable
                                           placeholder="选择注册班级">
                                    <el-option
                                        v-for="item in classRegItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.schoolId" @change="pageChange" filterable
                                           placeholder="选择学校">
                                    <el-option
                                        v-for="item in schoolItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>

                            <v-col cols="12" md="4" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-col cols="12" md="4">
                                        <v-btn color="primary" v-5="permissionCode.search" @click="pageChange" dark large>
                                            <v-icon left>mdi-magnify</v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.hideRemark="{ item }">
                            <div :title=item.hideRemark style="width:120px;overflow:hidden; white-space:nowrap; text-overflow:ellipsis">
                                {{ item.hideRemark }}
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" v-5="permissionCode.detail" x-small @click="showDetailDialog(item)" class="ml-2">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.show" class="ml-2" color="success"
                                   x-small @click="showStudent(item)">
                                <v-icon small>mdi-eye</v-icon>
                                显示
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-dialog v-model="showDetail" max-width="1000px">
            <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
        </v-dialog>
    </v-container>
</template>
<script>
    import scoreDetail from '../score/score-detail'

    export default {
        data() {
            return {
                permissionCode:{
                    search:'biz:blacklist:search',
                    show:'biz:blacklist:show',
                    detail:'biz:blacklist:detail',
                },
                showDetail:false,
                stuDetailMsg:{},
                studentDialog: false,
                addDialog: false,
                schoolMsg: {},
                dialog: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    name: '',
                    classId: '',
                    schoolId: '',
                    firstClassId:''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.name'), value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.className'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.firstClassName'), value: 'firstClassName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.schoolName'), value: 'schoolName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.source'),
                        value: 'sourceTypeDesc',
                        sortable: false,
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.changeClassNum'), value: 'transferTimes',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showStu.reason'), value: 'hideRemark',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
                classItems: [
                    {text: '选择隐藏前班级', value: ''},
                ],
                classRegItems: [
                    {text: '选择注册班级', value: ''},
                ],
                schoolItems: [
                    {text: '选择学校', value: ''},
                ],
            }

        },
        mounted(){
            this.initSelect()
        },
        methods: {
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            showStudent(item){
                this.$dialog.confirm("确定要显示该学生吗",'提示',()=>{
                    this.$api.student.unHideStudent({id:item.id}).then(data => {
                        if (data.flag) {
                            this.initialize()
                        }else {
                            this.$dialog.alert(data.msg)
                        }
                    })
                });
            },
            showDetailDialog(item) {
                this.showDetail = true;
                this.stuDetailMsg.studentId = item.id
            },
            initSchoolItems() {
                this.$api.school.getSchoolSelect().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.schoolItems.push({text: obj.schoolName, value: obj.id})
                        })
                    }
                })
            },
            initClassItems() {
                this.$api.classList.getAllClass().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.classItems.push({text: obj.className, value: obj.id})
                            if(obj.className != "长假人群"){
                                this.classRegItems.push({text: obj.className, value: obj.id})
                            }
                        })
                    }
                })
            },
            initSelect() {
                this.initClassItems()
                this.initSchoolItems()
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.student.getStudentList(
                    Object.assign({isHide:1}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })

            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components: {
            scoreDetail
        },
    }
</script>
<style></style>
